
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><div className='title'>So wird bestimmt, wo die Gefahrengebiete liegen</div>
<MDXTag name="p" components={components}>{`Ob ein Gebiet als gefährdet eingestuft wird, hängt davon ab, wie häufig und mit welcher Intensität Ereignisse wie Überschwemmungen oder Lawinen auftreten.
Die Einteilung erfolgt anhand eines Intensitäts-Wahrscheinlichkeits-Diagramms:`}</MDXTag>
<div className='imageContainer'>
  <img className='visual' src='images/matrix.svg' width='250px' />
</div>
<MDXTag name="p" components={components}><b>{`Intensität:`}</b><br/>{`Graduelle Prozesse wie der steigende Pegel eines Sees nach lang anhaltenden Niederschlägen sind für Menschen weniger gefährlich als sogenannt brutale Ereignisse, die ohne grosse Vorwarnzeit auftreten können. Beispiele für brutale Prozesse sind ein Felssturz oder ein Gebirgsbach, der nach einem lokalen Gewitter plötzlich über die Ufer tritt.`}</MDXTag>
<MDXTag name="p" components={components}><b>{`Wahrscheinlichkeit:`}</b><br/>{`Beim Erstellen von Gefahrenkarten wird unterschieden zwischen Ereignissen, die voraussichtlich alle 30, 100 oder 300 Jahre eintreten. Eine Zone kann auch dann als stark gefährdet eingestuft werden, wenn ein bestimmtes Ereignis nur alle 300 Jahre auftritt.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  